import axios from "axios";
export const url = 'https://api.peptalk.ir/v1' 
const api = axios.create({baseURL : url});
export default api;